import { Controller } from "@hotwired/stimulus"
import { sendAnalyticsEvent } from "../../lib/analytics_beacon"

// Rides on a card's share button: the copy is the clipboard controller's job,
// counting it is this one's.
export default class extends Controller {
  static values = { subjectType: String, subjectId: String, url: String }

  send() {
    if (!this.subjectTypeValue || !this.subjectIdValue) return

    sendAnalyticsEvent("content_shared", {
      subjectType: this.subjectTypeValue,
      subjectId: this.subjectIdValue,
      properties: { shared_link_id: this.urlValue, content_type: this.subjectTypeValue }
    })
  }
}
